import { CONVERSION } from '@/constants';
import { blurActiveElement } from '@/utils';

const PrivacyToggle = ({ type, disabled, onToggle, isPrivate }) => {
  const inputId = `${type}PrivacyToggle`;

  const isSingular = type === CONVERSION.single;

  return (
    <div className="privacy-toggle">
      <input
        id={inputId}
        type="checkbox"
        checked={isPrivate}
        disabled={disabled}
        onChange={(e) => {
          blurActiveElement();
          onToggle(e.target.checked);
        }}
        className="form-check-input me-2"
      />
      <label className="form-check-label" htmlFor={inputId}>
        Create private playlist{isSingular ? '' : 's'}
      </label>
    </div>
  );
};

export default PrivacyToggle;
